import { t } from 'i18next'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import React, { useRef } from 'react'

export const DeleteConfirmationDialog = (props: {
  visible: boolean;
  onClose: () => void;
  dataToDelete?: any | undefined;
  title?: string | undefined;
  message?: string | undefined;
  onDelete: () => void;
  acceptLabelKey?: string;
  rejectLabelKey?: string;
}): JSX.Element => {
  const toast = useRef<Toast>(null)

  const accept = () => {
    props.onDelete()
    toast?.current?.show({
      className: '',
      closable: true,
      content: undefined,
      contentClassName: '',
      contentStyle: undefined,
      sticky: false,
      style: undefined,
      severity: 'success',
      summary:
        t<string>('core.action.delete.confirmed.title') + ' - ' + props.title,
      detail: t<string>('core.action.delete.confirmed.message'),
      life: 2000,
    })
  }
  //
  // const reject = () => {
  //     toast?.current?.show({
  //         severity: 'info',
  //         summary: t<string>('core.action.delete.rejected.title') + ' - ' + props.title,
  //         detail: t<string>('core.action.delete.rejected.message'),
  //         life: 5000
  //     })
  // }

  return (
    <div>
      <ConfirmDialog
        visible={props.visible}
        onHide={props.onClose}
        header={t<string>('dialog.delete.title', { title: props.title })}
        message={props.message}
        icon={'pi pi-exclamation-triangle icon-orange'}
        acceptClassName={'p-button-danger'}
        accept={accept}
        //reject={reject}
        className={'dialog'}
        acceptLabel={
          props.acceptLabelKey
            ? t<string>(props.acceptLabelKey)
            : t<string>('core.yes')
        }
        rejectLabel={
          props.rejectLabelKey
            ? t<string>(props.rejectLabelKey)
            : t<string>('core.no')
        }
      />
      <Toast ref={toast} position={'bottom-right'} />
    </div>
  )
}